import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { AccountDataAnalysisOptions, defaultChartOrTableHeight, eurekaIPSortList, eurekaMaterialsSortList, eurekaRdSortList } from './AccountDataAnalysisService';
import { Symbols } from '@/symbols';
import _ from 'lodash';
import { AccountDataAnalysisDataSet, AccountDataAnalysisEventKey, AccountDataAnalysisKeyType, AccountDataAnalysisViewType } from '@/apis/service/account/AccountDataAnalysisApi.type';
import { searchColor } from '@/service/CompanyBase/CompanyDataAnalysis/echartsOption';
let AccountEurekaDataAnalysisService = class AccountEurekaDataAnalysisService {
    constructor(accountDataAnalysisService, accountDataAnalysisApi, i18n) {
        this.accountDataAnalysisService = accountDataAnalysisService;
        this.accountDataAnalysisApi = accountDataAnalysisApi;
        this.i18n = i18n;
        // 登录Eureka PV
        this.loginEurekaPvOption = new AccountDataAnalysisOptions();
        this.loginEurekaTotalDaysOption = new AccountDataAnalysisOptions();
        // RD PV
        this.rdPvOption = new AccountDataAnalysisOptions();
        this.rdTotalDaysOption = new AccountDataAnalysisOptions();
        // IP PV
        this.ipPvOption = new AccountDataAnalysisOptions();
        this.ipTotalDaysOption = new AccountDataAnalysisOptions();
        // Materials PV
        this.materialsPvOption = new AccountDataAnalysisOptions();
        this.materialsTotalDaysOption = new AccountDataAnalysisOptions();
        /**
         * 用户明细 table 配置
         */
        this.userDetailOption = new AccountDataAnalysisOptions();
        this.loginEurekaPvConfigInit();
        this.loginEurekaTotalDaysConfigInit();
        this.rdPvConfigInit();
        this.rdTotalDaysConfigInit();
        this.materialsPvConfigInit();
        this.materialsTotalDaysConfigInit();
        this.ipPvConfigInit();
        this.ipTotalDaysConfigInit();
        this.userDetailConfigInit();
    }
    loginEurekaPvConfigInit() {
        this.loginEurekaPvOption.reportName = AccountDataAnalysisKeyType.EUREKA_USER_LOGIN;
        this.loginEurekaPvOption.title = this.i18n.t('backoffice.company.dataAnalysis.loginPv');
        this.loginEurekaPvOption.tips = [{ desc: this.i18n.t('backoffice.company.dataAnalysis.loginEurekaPvTips') }];
        this.loginEurekaPvOption.canCollapse = false;
        const labels = {
            date: this.i18n.t('backoffice.company.dataAnalysis.date'),
            login_count: this.i18n.t('backoffice.company.dataAnalysis.loginPv'),
        };
        this.loginEurekaPvOption.tableOptions.columns = this.accountDataAnalysisService.getPvDaysTableColumns(labels);
        this.loginEurekaPvOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.loginEurekaPvOption.chartId = 'loginEurekaPvAnalysis';
        this.loginEurekaPvOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    loginEurekaTotalDaysConfigInit() {
        this.loginEurekaTotalDaysOption.reportName = AccountDataAnalysisKeyType.EUREKA_USER_LOGIN;
        this.loginEurekaTotalDaysOption.title = this.i18n.t('backoffice.account.dataAnalysis.eurekaOnlineDays');
        this.loginEurekaTotalDaysOption.tips = [{ desc: this.i18n.t('backoffice.account.dataAnalysis.eurekaOnlineDays') }];
        this.loginEurekaTotalDaysOption.canCollapse = false;
        const labels = {
            date: this.i18n.t('backoffice.company.dataAnalysis.date'),
            total_days: this.i18n.t('backoffice.company.dataAnalysis.eurekaLoginDays'),
        };
        this.loginEurekaTotalDaysOption.tableOptions.columns = this.accountDataAnalysisService.getPvDaysTableColumns(labels);
        this.loginEurekaTotalDaysOption.viewType = AccountDataAnalysisViewType.Chart;
        this.loginEurekaTotalDaysOption.canChangeViewType = true;
        this.loginEurekaTotalDaysOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.loginEurekaTotalDaysOption.chartId = 'loginEurekaTotalDaysAnalysis';
        this.loginEurekaTotalDaysOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    getLoginEurekaPvTotalDaysData(params) {
        this.loginEurekaPvOption.loading = true;
        this.loginEurekaTotalDaysOption.loading = true;
        const loginEurekaPvParams = { ...params, report_name: this.loginEurekaPvOption.reportName };
        return this.accountDataAnalysisApi.getAccountDataAnalysisData(loginEurekaPvParams).then((data) => {
            this.loginEurekaPvOption.Updated = data.data_date;
            this.loginEurekaTotalDaysOption.Updated = data.data_date;
            this.loginEurekaPvOption.noData = data.data_detail.length === 0;
            this.loginEurekaTotalDaysOption.noData = data.data_detail.length === 0;
            // const statistics = {
            //     total_count: data.total_count,
            //     total_days: data.total_days,
            //     key: 'eureka',
            // }
            // this.loginEurekaPvOption.statistics = this.accountDataAnalysisService.getPvDaysStatistics(statistics)
            // this.loginEurekaTotalDaysOption.statistics = this.accountDataAnalysisService.getPvDaysStatistics(statistics)
            this.loginEurekaPvOption.tableOptions.rows = this.accountDataAnalysisService.getPvDaysTableRows(data.data_detail, AccountDataAnalysisEventKey.LOGIN);
            this.loginEurekaTotalDaysOption.tableOptions.rows = this.accountDataAnalysisService.getPvDaysTableRows(data.data_detail, AccountDataAnalysisEventKey.LOGIN);
            this.loginEurekaPvOption.chartOption = this.accountDataAnalysisService.getAccountLineChartOption({
                data,
                sortList: [AccountDataAnalysisEventKey.LOGIN],
                dataSet: AccountDataAnalysisDataSet.TOTAL_COUNT,
                columns: [{
                        label: this.i18n.t('backoffice.company.dataAnalysis.loginPv'),
                        field: AccountDataAnalysisEventKey.LOGIN,
                    }],
            });
            // TOTAL_DAYS 图表配置 - 使用 getAccountLineChartOption
            this.loginEurekaTotalDaysOption.chartOption = this.accountDataAnalysisService.getAccountLineChartOption({
                data,
                sortList: [AccountDataAnalysisEventKey.LOGIN],
                dataSet: AccountDataAnalysisDataSet.TOTAL_DAYS,
                columns: [{
                        label: this.i18n.t('backoffice.account.dataAnalysis.eurekaOnlineDays'),
                        field: AccountDataAnalysisEventKey.LOGIN,
                    }],
            });
        }).finally(() => {
            this.loginEurekaPvOption.loading = false;
            this.loginEurekaTotalDaysOption.loading = false;
        });
    }
    rdPvConfigInit() {
        this.rdPvOption.reportName = AccountDataAnalysisKeyType.EUREKA_RD_USER_BEHAVIOR;
        this.rdPvOption.title = this.i18n.t('backoffice.company.dataAnalysis.commonPv');
        this.rdPvOption.tips = [{ desc: this.i18n.t('backoffice.company.dataAnalysis.commonPvTips') }];
        this.rdPvOption.viewType = AccountDataAnalysisViewType.Chart;
        this.rdPvOption.canChangeViewType = true;
        this.rdPvOption.canCollapse = false;
        this.rdPvOption.statistics = [];
        this.rdPvOption.tableOptions.columns = this.accountDataAnalysisService.getEurekaRdTableColumns();
        this.rdPvOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.rdPvOption.chartId = 'rdPv';
        this.rdPvOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    rdTotalDaysConfigInit() {
        this.rdTotalDaysOption.reportName = AccountDataAnalysisKeyType.EUREKA_RD_USER_BEHAVIOR;
        this.rdTotalDaysOption.title = this.i18n.t('backoffice.account.dataAnalysis.eurekaOnlineDays');
        this.rdTotalDaysOption.tips = [{ desc: this.i18n.t('backoffice.account.dataAnalysis.eurekaOnlineDays') }];
        this.rdTotalDaysOption.viewType = AccountDataAnalysisViewType.Chart;
        this.rdTotalDaysOption.canChangeViewType = true;
        this.rdTotalDaysOption.canCollapse = false;
        this.rdTotalDaysOption.statistics = [];
        this.rdTotalDaysOption.tableOptions.columns = this.accountDataAnalysisService.getEurekaRdTableColumns();
        this.rdTotalDaysOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.rdTotalDaysOption.chartId = 'rdTotalDays';
        this.rdTotalDaysOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    getRdPvTotalDaysData(params) {
        this.rdPvOption.loading = true;
        this.rdTotalDaysOption.loading = true;
        const rdParams = { ...params, report_name: this.rdPvOption.reportName };
        return this.accountDataAnalysisApi.getAccountDataAnalysisData(rdParams).then((data) => {
            this.rdPvOption.Updated = data.data_date;
            this.rdTotalDaysOption.Updated = data.data_date;
            this.rdPvOption.noData = data.data_detail.length === 0;
            this.rdTotalDaysOption.noData = data.data_detail.length === 0;
            if (this.rdPvOption.noData)
                return;
            this.rdPvOption.tableOptions.rows = this.accountDataAnalysisService.getAnalysisTableRows(data.data_detail, AccountDataAnalysisDataSet.TOTAL_COUNT);
            this.rdTotalDaysOption.tableOptions.rows = this.accountDataAnalysisService.getAnalysisTableRows(data.data_detail, AccountDataAnalysisDataSet.TOTAL_DAYS);
            this.rdPvOption.chartOption = this.accountDataAnalysisService.getStackBarCharOption({
                data,
                sortList: eurekaRdSortList,
                colorList: searchColor,
                dataSet: AccountDataAnalysisDataSet.TOTAL_COUNT,
                columns: this.accountDataAnalysisService.getEurekaRdTableColumns(),
            });
            this.rdTotalDaysOption.chartOption = this.accountDataAnalysisService.getStackBarCharOption({
                data,
                sortList: eurekaRdSortList,
                colorList: searchColor,
                dataSet: AccountDataAnalysisDataSet.TOTAL_DAYS,
                columns: this.accountDataAnalysisService.getEurekaRdTableColumns(),
            });
        }).catch(() => {
            this.rdPvOption.noData = true;
            this.rdTotalDaysOption.noData = true;
        }).finally(() => {
            this.rdPvOption.loading = false;
            this.rdTotalDaysOption.loading = false;
        });
    }
    ipPvConfigInit() {
        this.ipPvOption.reportName = AccountDataAnalysisKeyType.EUREKA_IP_USER_BEHAVIOR;
        this.ipPvOption.title = this.i18n.t('backoffice.company.dataAnalysis.commonPv');
        this.ipPvOption.tips = [{ desc: this.i18n.t('backoffice.company.dataAnalysis.commonPvTips') }];
        this.ipPvOption.viewType = AccountDataAnalysisViewType.Chart;
        this.ipPvOption.canChangeViewType = true;
        this.ipPvOption.canCollapse = false;
        this.ipPvOption.statistics = [];
        this.ipPvOption.tableOptions.columns = this.accountDataAnalysisService.getEurekaIPTableColumns();
        this.ipPvOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.ipPvOption.chartId = 'ipPv';
        this.ipPvOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    ipTotalDaysConfigInit() {
        this.ipTotalDaysOption.reportName = AccountDataAnalysisKeyType.EUREKA_IP_USER_BEHAVIOR;
        this.ipTotalDaysOption.title = this.i18n.t('backoffice.account.dataAnalysis.eurekaOnlineDays');
        this.ipTotalDaysOption.tips = [{ desc: this.i18n.t('backoffice.account.dataAnalysis.eurekaOnlineDays') }];
        this.ipTotalDaysOption.viewType = AccountDataAnalysisViewType.Chart;
        this.ipTotalDaysOption.canChangeViewType = true;
        this.ipTotalDaysOption.canCollapse = false;
        this.ipTotalDaysOption.statistics = [];
        this.ipTotalDaysOption.tableOptions.columns = this.accountDataAnalysisService.getEurekaIPTableColumns();
        this.ipTotalDaysOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.ipTotalDaysOption.chartId = 'ipTotalDays';
        this.ipTotalDaysOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    getIpPvTotalDaysData(params) {
        this.ipPvOption.loading = true;
        this.ipTotalDaysOption.loading = true;
        const ipParams = { ...params, report_name: this.ipPvOption.reportName };
        return this.accountDataAnalysisApi.getAccountDataAnalysisData(ipParams).then((data) => {
            this.ipPvOption.Updated = data.data_date;
            this.ipTotalDaysOption.Updated = data.data_date;
            this.ipPvOption.noData = data.data_detail.length === 0;
            this.ipTotalDaysOption.noData = data.data_detail.length === 0;
            if (this.ipPvOption.noData)
                return;
            this.ipPvOption.tableOptions.rows = this.accountDataAnalysisService.getAnalysisTableRows(data.data_detail, AccountDataAnalysisDataSet.TOTAL_COUNT);
            this.ipTotalDaysOption.tableOptions.rows = this.accountDataAnalysisService.getAnalysisTableRows(data.data_detail, AccountDataAnalysisDataSet.TOTAL_DAYS);
            this.ipPvOption.chartOption = this.accountDataAnalysisService.getStackBarCharOption({
                data,
                sortList: eurekaIPSortList,
                colorList: searchColor,
                dataSet: AccountDataAnalysisDataSet.TOTAL_COUNT,
                columns: this.accountDataAnalysisService.getEurekaIPTableColumns(),
            });
            this.ipTotalDaysOption.chartOption = this.accountDataAnalysisService.getStackBarCharOption({
                data,
                sortList: eurekaIPSortList,
                colorList: searchColor,
                dataSet: AccountDataAnalysisDataSet.TOTAL_DAYS,
                columns: this.accountDataAnalysisService.getEurekaIPTableColumns(),
            });
        }).catch(() => {
            this.ipPvOption.noData = true;
            this.ipTotalDaysOption.noData = true;
        }).finally(() => {
            this.ipPvOption.loading = false;
            this.ipTotalDaysOption.loading = false;
        });
    }
    materialsPvConfigInit() {
        this.materialsPvOption.reportName = AccountDataAnalysisKeyType.EUREKA_MATERIAL_USER_BEHAVIOR;
        this.materialsPvOption.title = this.i18n.t('backoffice.company.dataAnalysis.commonPv');
        this.materialsPvOption.tips = [{ desc: this.i18n.t('backoffice.company.dataAnalysis.commonPvTips') }];
        this.materialsPvOption.viewType = AccountDataAnalysisViewType.Chart;
        this.materialsPvOption.canChangeViewType = true;
        this.materialsPvOption.canCollapse = false;
        this.materialsPvOption.statistics = [];
        this.materialsPvOption.tableOptions.columns = this.accountDataAnalysisService.getEurekaMaterialsTableColumns();
        this.materialsPvOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.materialsPvOption.chartId = 'materialsPv';
        this.materialsPvOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    materialsTotalDaysConfigInit() {
        this.materialsTotalDaysOption.reportName = AccountDataAnalysisKeyType.EUREKA_MATERIAL_USER_BEHAVIOR;
        this.materialsTotalDaysOption.title = this.i18n.t('backoffice.account.dataAnalysis.eurekaOnlineDays');
        this.materialsTotalDaysOption.tips = [{ desc: this.i18n.t('backoffice.account.dataAnalysis.eurekaOnlineDays') }];
        this.materialsTotalDaysOption.viewType = AccountDataAnalysisViewType.Chart;
        this.materialsTotalDaysOption.canChangeViewType = true;
        this.materialsTotalDaysOption.canCollapse = false;
        this.materialsTotalDaysOption.statistics = [];
        this.materialsTotalDaysOption.tableOptions.columns = this.accountDataAnalysisService.getEurekaMaterialsTableColumns();
        this.materialsTotalDaysOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.materialsTotalDaysOption.chartId = 'materialsTotalDays';
        this.materialsTotalDaysOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    getMaterialsPvTotalDaysData(params) {
        this.materialsPvOption.loading = true;
        this.materialsTotalDaysOption.loading = true;
        const materialsParams = { ...params, report_name: this.materialsPvOption.reportName };
        return this.accountDataAnalysisApi.getAccountDataAnalysisData(materialsParams).then((data) => {
            this.materialsPvOption.Updated = data.data_date;
            this.materialsTotalDaysOption.Updated = data.data_date;
            this.materialsPvOption.noData = data.data_detail.length === 0;
            this.materialsTotalDaysOption.noData = data.data_detail.length === 0;
            if (this.materialsPvOption.noData)
                return;
            this.materialsPvOption.tableOptions.rows = this.accountDataAnalysisService.getAnalysisTableRows(data.data_detail, AccountDataAnalysisDataSet.TOTAL_COUNT);
            this.materialsTotalDaysOption.tableOptions.rows = this.accountDataAnalysisService.getAnalysisTableRows(data.data_detail, AccountDataAnalysisDataSet.TOTAL_DAYS);
            this.materialsPvOption.chartOption = this.accountDataAnalysisService.getStackBarCharOption({
                data,
                sortList: eurekaMaterialsSortList,
                colorList: searchColor,
                dataSet: AccountDataAnalysisDataSet.TOTAL_COUNT,
                columns: this.accountDataAnalysisService.getEurekaMaterialsTableColumns(),
            });
            this.materialsTotalDaysOption.chartOption = this.accountDataAnalysisService.getStackBarCharOption({
                data,
                sortList: eurekaMaterialsSortList,
                colorList: searchColor,
                dataSet: AccountDataAnalysisDataSet.TOTAL_DAYS,
                columns: this.accountDataAnalysisService.getEurekaMaterialsTableColumns(),
            });
        }).catch(() => {
            this.materialsPvOption.noData = true;
            this.materialsTotalDaysOption.noData = true;
        }).finally(() => {
            this.materialsPvOption.loading = false;
            this.materialsTotalDaysOption.loading = false;
        });
    }
    userDetailConfigInit() {
        this.userDetailOption.reportName = AccountDataAnalysisKeyType.EUREKA_USER_COMPREHENSIVE;
        this.userDetailOption.title = this.i18n.t('backoffice.company.dataAnalysis.userDetails');
        this.userDetailOption.tips = [
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.eurekaLoginDays'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.eurekaLoginDaysTips'),
            },
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.eurekaLoginCount'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.eurekaLoginCountTips'),
            },
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.eurekaLoginTotalCount'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.eurekaLoginTotalCountTips'),
            },
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.joinDate'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.joinDateTips'),
            }
        ];
        this.userDetailOption.canCollapse = false;
        this.userDetailOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeight;
        this.userDetailOption.tableOptions.paginationOptions.enabled = true;
        this.userDetailOption.tableOptions.paginationOptions.perPageDropdownEnabled = false;
        this.userDetailOption.canChangeViewType = false;
        this.userDetailOption.viewType = AccountDataAnalysisViewType.Table;
        this.userDetailOption.tableFields = this.accountDataAnalysisService.getEurekaActiveUserTableColumns();
        this.userDetailOption.tableOptions.columns = this.userDetailOption.tableFields;
    }
    async getEurekaUserDetailData(params) {
        let eurekaActiveUserDetailParams = _.cloneDeep(params);
        this.userDetailOption.loading = true;
        eurekaActiveUserDetailParams = this.accountDataAnalysisService.getDetailTableDefaultParams(params, this.userDetailOption.reportName);
        // 先获取字段设置
        this.userDetailOption.tableOptions.columns = await this.accountDataAnalysisService.getFiledSettingColumns(this.userDetailOption.reportName, this.userDetailOption.tableFields);
        return this.accountDataAnalysisApi.postAccountDataAnalysisUserUsageSummary(eurekaActiveUserDetailParams).then(data => {
            this.userDetailOption.noData = false;
            this.userDetailOption.tableOptions.paginationOptions.setCurrentPage = 1;
            this.userDetailOption.tableOptions.totalRecords = 1;
            this.userDetailOption.tableOptions.totalRows = 1;
            this.userDetailOption.tableOptions.rows = this.accountDataAnalysisService.getEurekaActiveUserTableRows([data]);
        }).catch(() => {
            this.userDetailOption.noData = true;
            this.userDetailOption.tableOptions.rows = [];
        }).finally(() => {
            this.userDetailOption.loading = false;
        });
    }
    getAccountDataAnalysisEurekaUsageDownload(params) {
        let eurekaActiveUserDetailParams = _.cloneDeep(params);
        eurekaActiveUserDetailParams = this.accountDataAnalysisService.getDetailTableDefaultParams(params, this.userDetailOption.reportName);
        return this.accountDataAnalysisApi.postAccountDataAnalysisUserUsageDownload(eurekaActiveUserDetailParams, 'eureka-usage');
    }
    initData(params) {
        Promise.all([
            this.getLoginEurekaPvTotalDaysData(params),
            this.getRdPvTotalDaysData(params),
            this.getIpPvTotalDaysData(params),
            this.getMaterialsPvTotalDaysData(params)
        ]);
    }
};
AccountEurekaDataAnalysisService = __decorate([
    injectable(),
    __param(0, inject(Symbols.AccountDataAnalysisService)),
    __param(1, inject(Symbols.AccountDataAnalysisApi)),
    __param(2, inject(Symbols.I18n)),
    __metadata("design:paramtypes", [Object, Object, Object])
], AccountEurekaDataAnalysisService);
export { AccountEurekaDataAnalysisService };
